import { render, staticRenderFns } from "./journalOfEqSK.vue?vue&type=template&id=42b52fdc&scoped=true"
import script from "./journalOfEqSK.vue?vue&type=script&lang=js"
export * from "./journalOfEqSK.vue?vue&type=script&lang=js"
import style0 from "./journalOfEqSK.vue?vue&type=style&index=0&id=42b52fdc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b52fdc",
  null
  
)

export default component.exports